module.exports = __webpack_public_path__ + "static/media/img.b4bf88d7.png";